export default __webpack_public_path__ + "1c7ff4df87bdf53d2a8effe4625ed587.png";